import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Список заявок на разрешение организации
  listApplicationByOopt (id, filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/licenseApplication/getOoptApplicationPermits/${id}?${filter}`)
  },
  // Список заявок на разрешение
  listApplication (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/licenseApplication/getUserApplicationPermits?${filter}`)
  },
  // Создание заявки на разрешение
  createApplication (id) {
    return axios.get(`${i18n.locale}/api/licenseApplication/createApplicationPermit/${id}`)
  },
  // Получение данных для отображения заявки на разрешение
  showApplication (id) {
    return axios.get(`${i18n.locale}/api/licenseApplication/getApplicationPermitInfo/${id}`)
  },
  // Получение данных для формы заявки на разрешение
  getApplicationFormData () {
    return axios.get(`${i18n.locale}/api/licenseApplication/getApplicationPermitFormData`)
  },
  // Обновление заявки на квоту
  updateApplication (id, statusId, data) {
    return axios.post(`${i18n.locale}/api/licenseApplication/editApplicationPermit/${id}/${statusId}`, data)
  },
  faunaLicenseList (id) {
    return axios.get(`${i18n.locale}/api/licenseApplication/getFaunaLicenseApplicationsByApplicationPermit/${id}`)
  },
  // Создание сущности FaunaLicense
  createFaunaLicense (id) {
    return axios.get(`${i18n.locale}/api/licenseApplication/createFaunaLicenseApplication/${id}`)
  },
  // Удаление сущности FaunaLicense
  deleteFaunaLicense (id) {
    return axios.delete(`${i18n.locale}/api/licenseApplication/deleteFaunaLicenseApplication/${id}`)
  },
  // Обновление сущности FaunaLicense
  updateFaunaLicense (id, data) {
    return axios.post(`${i18n.locale}/api/licenseApplication/editFaunaLicenseApplication/${id}`, data)
  },
  // Удаление сущности документа заявки
  deleteDocument (id) {
    return axios.delete(`${i18n.locale}/api/licenseApplication/deleteApplicationPermitDocument/${id}`)
  },
  // Получение данных для формы заявки на разрешение
  getApplicationDocumentFormData () {
    return axios.get(`${i18n.locale}/api/licenseApplication/getApplicationPermitDocumentFormData`)
  },
  // Получение данных для отображения документа заявки на разрешение
  showApplicationDocument (id) {
    return axios.get(`${i18n.locale}/api/licenseApplication/getApplicationPermitDocumentInfo/${id}`)
  },
  // Создание/обновление документа заявки на квоту
  updateApplicationDocument (params, data) {
    return axios.post(`${i18n.locale}/api/licenseApplication/${params.route}/${params.id}`, data)
  },
  // Список действий
  getApplicationActions (statusId) {
    return axios.get(`${i18n.locale}/api/licenseApplication/actions/${statusId}`)
  },
  // Изменение статуса
  changeStatusApplication (id, data) {
    return axios.post(`${i18n.locale}/api/licenseApplication/changeStatus/${id}`, data)
  },
  // отклонение заявки
  refuseApplication (id, data) {
    return axios.post(`${i18n.locale}/api/licenseApplication/refuseApplicationPermit/${id}`, data)
  },
  // Список типов БСО для выдачи
  getBsosForApplicationPermit (id) {
    return axios.get(`${i18n.locale}/api/licenseApplication/getBsosForApplicationPermit/${id}`)
  },
  // Выдача БСО
  saveFaunaLicenseApplicationBsos (id, data) {
    return axios.post(`${i18n.locale}/api/licenseApplication/saveFaunaLicenseApplicationBsos/${id}`, data)
  },
  // Список выданных БСО
  getFaunaLicenseApplicationsWithBsos (id) {
    return axios.get(`${i18n.locale}/api/licenseApplication/getFaunaLicenseApplicationsWithBsos/${id}`)
  },
  // выдача заявки
  approveApplication (id, statusId, data) {
    return axios.post(`${i18n.locale}/api/licenseApplication/approveApplicationPermit/${id}/${statusId}`, data)
  },
  // Данные формы для привязки
  getParentFaunaLicenseApplicationBsoInfo (id) {
    return axios.get(`${i18n.locale}/api/licenseApplication/getParentFaunaLicenseApplicationBsoInfo/${id}`)
  },
  // Привязка выданных БСО к разрешению
  setParentFaunaLicenseApplicationBso (id, data) {
    return axios.post(`${i18n.locale}/api/licenseApplication/setParentFaunaLicenseApplicationBso/${id}`, data)
  }
}
